// Recently opened games and their pinned commits (small; kept in localStorage).
import type { GameLink } from '../../shared/links.ts';

export interface LibraryEntry {
  key: string;
  link: GameLink;
  commit: string;
  id: string;
  title: string;
  platform: string;
  openedAt: number;
}

const KEY = 'rtw:library';

export function linkKey(l: GameLink): string {
  return `${l.owner.toLowerCase()}/${l.repo.toLowerCase()}@${l.ref ?? ''}:${l.path}`;
}

export interface KV { getItem(k: string): string | null; setItem(k: string, v: string): void }

function store(): KV | null {
  try { return globalThis.localStorage ?? null; } catch { return null; }
}

export function listLibrary(kv: KV | null = store()): LibraryEntry[] {
  try {
    const v = JSON.parse(kv?.getItem(KEY) ?? '[]');
    return Array.isArray(v) ? (v as LibraryEntry[]).sort((a, b) => b.openedAt - a.openedAt) : [];
  } catch { return []; }
}

export function getEntry(l: GameLink, kv: KV | null = store()): LibraryEntry | undefined {
  return listLibrary(kv).find((e) => e.key === linkKey(l));
}

export function putEntry(e: Omit<LibraryEntry, 'key' | 'openedAt'>, kv: KV | null = store()): void {
  if (!kv) return;
  const key = linkKey(e.link);
  const rest = listLibrary(kv).filter((x) => x.key !== key);
  const list = [{ ...e, key, openedAt: Date.now() }, ...rest].slice(0, 50);
  try { kv.setItem(KEY, JSON.stringify(list)); } catch { /* full */ }
}
